import Tooltip from "../components/Tooltip";

export const VideoData = [
  {
    id: "843697919",
    title: <>Watch Dr. Philley explain who is at risk for <Tooltip>MAC</Tooltip></>,
    chapters: [],
    transcript: (
      <>
        <p className="mb-4">MAC stands for <em>Mycobacterium avium</em> complex, and this is the most common NTM lung disease in the United States. It actually accounts for about 80% of what we see in NTM.</p>
        <p className="mb-4"><strong>Who is at risk of getting NTM lung disease?</strong></p>
        <p>Individuals with certain underlying lung disease, diseases like bronchiectasis or dilated floppy bronchial tubes, or other diseases, like asthma or COPD, are often associated with NTM. Other patients that are on drugs which suppress the immune system are also at risk to develop NTM.</p>

      </>
    ),
  },
  {
    id: "843697954",
    title: "Hear Dr. Philley explain treatment goals",
    chapters: [],
    transcript: (
      <>    
        <p className="mb-4"><strong>What are the goals of treatment?</strong></p>
        <p>The goals of successful treatment are to convert the patient's sputum to negative, and that means that they no longer grow NTM in their sputum&mdash;and successful treatment implies that they take 12 months of therapy with negative sputum cultures. Other goals include improvement in radiographs, things like CAT scans or chest x-rays, although that can be complicated in patients with underlying structural lung disease, but also the patient's symptoms, improvement in symptoms is also incredibly important.</p>
      </>
    ),
  },  
  {
    id: "843697848",
    title: "How one patient’s determination led to an action plan",
    chapters: [],
    transcript: (
      <>
        <p><strong>Debbie on Managing NTM Lung Disease&nbsp; </strong></p>
        <p className="mb-4">NTM=nontuberculous mycobacteria.</p>
        <p>I felt a great relief knowing that I could do something about NTM, the condition that I now could put a name to. And I was very optimistic. I was told that I was in initial stages, and that was a definite positive. So, I decided to look at this, that, okay, I&rsquo;m going to get this. It&rsquo;s not going to get me.</p>
      </>
    ),
  }
];